import { createAction, props } from "@ngrx/store";
import { EntityId, IPerson } from "src/app/interfaces";

export const loadPersonByLogin = createAction(
  "[Person/API] Load Persons by login",
  props<{ login: EntityId }>()
);

export const loadPersonByLoginNotNecessary = createAction(
  "[Person/API] Load Person by login not necessary",
  props<{ person: IPerson }>()
);

export const loadPersonByLoginSuccess = createAction(
  "[Person/API] Load Person by login Success",
  props<{ person: IPerson }>()
);

export const loadPersonByLoginFailure = createAction(
  "[Person/API] Load Person by login Fail",
  props<{ error: string }>()
);
